import { IconProps } from "@radix-ui/react-icons/dist/types";
import * as React from "react";

export const StrokeSmallIcon = React.memo(function ({
  color = "currentColor",
  ...props
}: IconProps) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="7.5" cy="7.5" r="1.5" fill={color} />
    </svg>
  );
});
